import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import hero from './sections/hero';
import contact from './sections/contact';
import text from './sections/text';
import columns from './sections/columns';
import nextSection from './sections/nextSection';

init();
modalSection();
headerSection();
hero();
contact();
text();
columns();
nextSection();



// WEBPACK FOOTER //
// ./source/scripts/main.js